import React from 'react'
import { AuthInitializer } from '../AuthInitializer'
import { GeneralLayoutComponent } from '../GeneralLayout'
import { PostHogProvider } from 'posthog-js/react'

interface LayoutProps {
  children: React.ReactNode;
}

(() => {
  if (window.localStorage.getItem('debug') === 'true') {
    const env = import.meta.env
    console.log('import.meta.env', env)
  }
})()

const postHogAPIHost = 'https://eu.i.posthog.com'
// const postHogAPIHost = window.location.origin.includes('localhost') ? 
//       'https://eu.i.posthog.com' : 'https://ph.xp-lab.com'

const phOptions = {
  api_host: postHogAPIHost,
  ui_host: 'https://eu.posthog.com',
  defaults: '2025-05-24',
} as const

const MetricsProvider = ({ children }: { children: React.ReactNode }) => {
  if (import.meta.env.MODE === 'development') {
    return children
  }
  return (
    <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={phOptions}>
      {children}
    </PostHogProvider>
  )
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <MetricsProvider>
      <AuthInitializer>
        <GeneralLayoutComponent>
          {children}
        </GeneralLayoutComponent>
      </AuthInitializer>
    </MetricsProvider>
  )
}
